<template>
  <div>
    <Modal v-model="isShow" :mask-closable="false" @on-ok="ok"
           :loading="loading" @on-cancel="cancel" :width="830" class="mask long-modal">
      <h3 slot="header" class="modal-header">结算信息2</h3>
      <h4 class="mb8">结算明细：</h4>
      <div class="mb32">
        <Row class="row">
          <Col span="4">费用项</Col>
          <Col span="5">应缴费用</Col>
          <Col span="5">已缴费用</Col>
          <Col span="5">应退费用</Col>
          <Col span="5">实退费用</Col>
        </Row>
        <Row class="row " v-for="(item,index) in data" :key="'keyA'+index">
          <Form :model="item" :inline="true" :rules="formRules" :ref="'form1'+index">
            <Col span="4">{{item.expenseItemName}}</Col>
            <Col span="5" class="textright">
              {{item.receivableAmount?formatMoney(item.receivableAmount):(item.receivableAmount===0?0:'-')}}
            </Col>
            <Col span="5" class="textright">{{item.receivedAmount?formatMoney(item.receivedAmount):(item.receivedAmount===0?0:'-')}}</Col>
            <Col span="5" class="textright">{{item.refundAmount?formatMoney(item.refundAmount):(item.refundAmount===0?0:'-')}}</Col>
            <Col span="5" class="textright">
              <FormItem prop="actRefundAmount" class="notip">
                <Input class="inputwidth " v-model="item.actRefundAmount"/>
              </FormItem>
            </Col>
          </Form>
        </Row>
        <Row class="row ">
          <Col span="4">合计</Col>
          <Col span="5" class="textright">{{formatMoney(receivableAmountSum)}}</Col>
          <Col span="5" class="textright">{{formatMoney(receivedAmountSum)}}</Col>
          <Col span="5" class="textright">{{formatMoney(refundAmountSum)}}</Col>
          <Col span="5" class="textright">{{formatMoney(actRefundAmountSum)}}</Col>
        </Row>
      </div>

      <div class="notopcheck">
        <h4 class="mb8">未核销账单: <span class="text-red">选中后表示该帐单将和解约结算明细合并收付款，未选中账单将在解约协议审核通过后作废；清退时账单不可选。</span></h4>
        <!--<Table ref="billTable" :data="dataBill"-->
               <!--:columns="columnsBill"-->
               <!--@on-selection-change="selectChange"-->
               <!--@on-select="onselect"-->
        <!--&gt;</Table>-->
        <div>
          <Row class="row">
            <Col span="5">帐单编号</Col>
            <Col span="5">费用项</Col>
            <Col span="5">账单金额</Col>
            <Col span="5">核销状态</Col>
            <Col span="4"></Col>
          </Row>
          <Row class="row" v-for="item,index in dataBill" :key="'keyTF'+index">
            <Col span="5">{{item.billNumber}}</Col>
            <Col span="5">{{item.finExpenseItemName || '-'}}</Col>
            <Col span="5" style="text-align: right">{{Number(item['feeAmount']/100).toFixed(2)}}</Col>
            <Col span="5">{{item.verificateStatusName}}</Col>
            <Col span="4">
              <Checkbox v-model="item.selected" @on-change="checkNoItem(item)" :disabled="surBaseInfo.surType==9"></Checkbox>
            </Col>
          </Row>
          <div v-if="!dataBill.length"  class="row ivu-row">暂无数据</div>
        </div>
      </div>
    </Modal>
  </div>
</template>
<script>
  import {deepClone} from "../../../../../utils/format";
  import {modifyCostDetail, getNoCancelBills, saveNoCancelBills} from "../../../../../api/contractList";
  import {formatMoney} from "../../../../../utils/format";
  import {isEnteredCertificate} from "../../../../../api/contractList";

  export default {
    name: "UpdateSettle",
    components: {},
    props: {
      n: {
        type: Number,
        default: 0
      },
      dataOri: {
        type: Array,
        default: () => {
          return []
        }
      },
      surFid: {
        type: String,
        default: ""
      },
      nocancelSurFid:{
        type:String,
        default:''

      },
    surBaseInfo:{
        type:Object,
        default:null
    }
    },
    watch: {
      n() {
        this.data = deepClone(this.dataOri)
        this.resetFields()
        this.dataBill=[]
        this.getNoCancelBills()
        this.isShow = true
      }
    },
    computed: {
      selection(){
        return this.dataBill.filter(ele=>{
          return ele.selected
        })

      },
      receivableAmountSum() {
        let ret = 0
        this.data.forEach(ele => {
          ret += Number(ele.receivableAmount)
        })
        return ret.toFixed(2)
      },
      receivedAmountSum() {
        let ret = 0
        this.data.forEach(ele => {
          ret += Number(ele.receivedAmount)
        })
        return ret.toFixed(2)
      },
      actRefundAmountSum() {
        let ret = 0
        this.data.forEach(ele => {
          ret += Number(ele.actRefundAmount)
        })
        return ret.toFixed(2)
      },
      refundAmountSum() {
        let ret = 0
        this.data.forEach(ele => {
          ret += Number(ele.refundAmount)
        })
        return ret.toFixed(2)
      },
    },
    data() {
      return {

        columnsBill: [
          {
            title: "帐单编号",
            key: "billNumber",
            align: "center"
          },
          {
            title: "费用项",
            key: "finExpenseItemName",
            align: "center"
          },
          {
            title: "账单金额",
            key: "feeAmount",
            align: "center",
            render:(h,params)=>{
              return h('div',{
                style:{
                  // width:'100px',
                  textAlign:'right'
                }
              },Number(params.row['feeAmount']/100).toFixed(2))

            },

          },
          {
            title: "核销状态",
            key: "verificateStatusName",
            align: "center"
          },
          {
            type: 'selection',
            width: 60,
            align: 'center'
          },

        ],
        dataBill: [],
        formRules: {
          actRefundAmount: [
            {required: true, trigger: 'blur', message: ' ', validator: this.validateNumber}
          ]
        },
        data: deepClone(this.dataOri),
        loading: true,
        isShow: false,
      }
    },
    methods: {
      checkNoItem(item){
        if(!item.selected){
          return
        }
        isEnteredCertificate({billNum:item.billNumber}).then(res=>{

        }).catch(error=>{
          console.log('changing.....')
          item.selected=false
        }).finally(()=>{
        })
      },
      getNoCancelBills() {
        if (!this.nocancelSurFid) {
          return
        }
        const params = {
          surrenderFid: this.nocancelSurFid,
          isUpdate: '1'
        }
        getNoCancelBills(params).then(res => {
          if(!res.data){
            return
          }
          this.dataBill=res.data
        }).catch(() => {
          return
        })

      },
      formatMoney: formatMoney,
      resetFields() {
        for (const i in this.$refs) {
          this.$refs[i][0] && this.$refs[i][0].resetFields()
        }
      },
      changeLoading() {
        this.loading = false;
        this.$nextTick(() => {
          this.loading = true
        })
      },
      validateNumber(rule, value, callback) {
        const pattern = /^(-?\d+)(\.\d+)?$/
        if (!pattern.test(value)) {
          callback(new Error('请输入正确数字'));
        }
        callback();
      },
      ok() {

        let inputValid = true
        for (const i in this.$refs) {
          this.$refs[i][0] && this.$refs[i][0].validate(bool => {
            !bool && (inputValid = false)
          })
        }
        if (!inputValid) {
          this.$Message.info('请检查录入信息')
          this.changeLoading()
          return
        }
        const params={
          surrenderBalanceDtos:this.data,
          cancelBillDtos:this.dataBill
        }

        modifyCostDetail(params).then(res => {
          this.$Message.info('结算信息修改成功')
          this.$emit('done')
          this.isShow = false
        }).catch(error => {
          this.$Message.info('结算信息修改失败')
          this.changeLoading()
          // this.$emit('done')
          // this.isShow4=false
        })
      },
      cancel() {

      }
    }

  }
</script>

<style scoped>
  .textright{
    text-align: right;
  }
  .inputwidth {
    width: 80%;
  }

  .row {
    text-align: center;
    /*margin-bottom: 10px;*/
    line-height: 32px;
    border-left: 1px solid rgb(222, 222, 222);
    border-right: 1px solid rgb(222, 222, 222);
    border-bottom: 1px solid rgb(222, 222, 222);
    padding: 7px;
    font-weight: bold;
  }

  .row:first-child {
    border-top: 1px solid rgb(222, 222, 222);
    background-color: rgb(248, 248, 248);
    padding: 5px;
  }

</style>
